module.exports = __webpack_public_path__ + "static/media/Animals.9dfc61e5.png";